import { FORM_LOADER, DASHBOARD_CONTAINER } from '../../../types/types';
import { USER_SETTINGS_FORM } from './form-user-settings-types';
import { dropdown, displaySelectedValue } from '../../dropdown';

import { IUserSettings } from '../../../models/settings.interface';
import GetUserSettings from '../../../routes/get-user-settings';

/**
 * The form for the user settings
 * 
 * @returns void
 */
const GetSettingsUser = async () => {
  if ( !USER_SETTINGS_FORM.settingForm ) return;

  const body = await GetUserSettings();

  populateUserSettings(body)
}

/**
 * Populates the user settings form with the user's information
 * 
 * @param {any} data the user's information
 * 
 * @returns void
 */
const populateUserSettings = (data: IUserSettings) => {
  const { FirstName, LastName, SelectedName, DisplayNames, Email } = data;

  USER_SETTINGS_FORM.settingFirstName.value = FirstName;
  USER_SETTINGS_FORM.settingLastName.value = LastName;

  const userNameData = Object.values(DisplayNames).map((value: any) => ({ id: value, name: value }));

  dropdown(userNameData, 'user-name', 'User', false, true, true);
  displaySelectedValue('.aafp_list-user-name', 'user-name', SelectedName);

  FORM_LOADER.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');
}

export default GetSettingsUser;